<div id="active-section" class="session-section">
  <div>
    <span class="session-header-bold">Active Session</span>
    <span class="session-header-dim"></span>
  </div>

  <modal-component #hmlPreview
                   (accept)="hmlPreviewAccepted($event)"
                   (reject)="hmlPreviewRejected($event)"
                   [title]="modalTitle"
                   [data]="{
                    okBtnTitle:'Accept & Continue',
                    okBtnCssClass:'btn btn-primary hml-button-accept',
                    cancelBtnTitle: 'Reject File',
                    cancelBtnAutoHide: false,
                    cancelBtnCssClass:'btn btn-default hml-button-reject',
                    footerMessage: 'You are accepting responsibility for the accuracy of this file and the contents.'}">
      <div [innerHTML]="modalContent"></div>
  </modal-component>

  <modal-component #rejectConfirmation
                   (accept)="hmlRejectionCancellation($event)"
                   (reject)="hmlRejectConfirmation($event)"
                   [title]="modalTitle2"
                   [data]="{
                    small: true,
                    resizeOrClose:'close',
                    okBtnTitle:'Cancel',
                    okBtnCssClass:'btn btn-default hml-button-cancel-reject',
                    cancelBtnTitle: 'Reject File',
                    cancelBtnCssClass:'btn btn-default hml-button-accept-reject',
                    footerMessage: ''}">
      <div>
          Are you sure you want to reject converted HML file?<br><br>
          No further action will be available for this file.
      </div>
  </modal-component>

  <modal-component #fileDownload
                   (accept)="closeAndContinue($event)"
                   (reject)="downloadFile($event)"
                   [title]="modalTitle"
                   [data]="{
                    okBtnTitle:'Close & Continue',
                    okBtnCssClass:'btn btn-primary hml-button-close-continue',
                    cancelBtnCssClass:'btn btn-default hml-button-download-file',
                    cancelBtnAutoHide: false,
                    footerMessage: 'Validation has not been performed yet on this file and it may contain errors.'}">
      <div [innerHTML]="modalContent"></div>
  </modal-component>

  <modal-component #validateOrSubmit
            (accept)="doSubmitHml($event)"
            (reject)="doValidateHml($event)"
            [title]="modalTitle"
            [data]="{
            small: true,
            resizeOrClose:'close',
            okBtnTitle:'Validate/Submit',
            okBtnCssClass:'btn btn-primary hml-button-accept',
            cancelBtnTitle: 'Validate Only',
            cancelBtnCssClass:'btn btn-default hml-button-validate',
            footerMessage: ''}">
      <div>
          Validation is automatically done as part of <br>
          the submission process.<br><br>
          Would you like to validate and submit in one step?
      </div>
  </modal-component>

 <modal-component #transmissionError
                   (accept)="closeAndContinue($event)"
                   [title]="modalTitle"
                   [data]="{
                    small: true,
                    resizeOrClose:'close',
                    okBtnTitle:'Close & Continue',
                    okBtnCssClass:'btn btn-primary hml-button-close-continue',
                    cancelBtnTitle: '',
                    cancelBtnCssClass:'btn btn-default hml-button-download-file',
                    cancelBtnAutoHide: true}">
      <div style="text-align: center;" [innerHTML]="modalContent"></div>
  </modal-component>


  <validation-errors></validation-errors>

  <div class="session-table">
    <table aria-describedby="Active Session Table" class="table" id="activeSessionTable">
      <colgroup>
        <col *ngFor="let percent of columnWidths"
            [ngStyle]="{ 'width': percent }">
      </colgroup>
      <thead>
      <tr>
        <th id="session-header" *ngFor="let name of headers">{{name}}</th>
      </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fileRecord of activeFileRecordList"
            [file-record]="fileRecord"
            scope="active"
            (evtCsvConversion)="doConvertCsv($event)"
            (evtValOrSubmission)="validateOrSubmitHml($event)"
            (evtValErrors)="showValidationErrors($event)"
            (evtSubmision)="doSubmitHml($event)"
            (evtViewFile)="viewSubmittedFile($event)"></tr>
      </tbody>
    </table>
  </div>
</div>

<div id="toggle-section">
  <button id="toggle-button" type="button" class="btn" data-bs-toggle="collapse" data-bs-target="#previous-section" (click)="toggleCollapse()">Show Previous
    Sessions
  </button>
</div>

<div #collapse="ngbCollapse" [(ngbCollapse)]="previousSectionCollapsed" id="previous-section" class="session-section">
  <div>
    <span class="session-header-bold">Previous Sessions</span>
  </div>

  <div class="session-table">
    <table aria-describedby="Previous Session Table" class="table" id="previousSessionTable">
      <colgroup>
        <col *ngFor="let percent of columnWidths"
            [ngStyle]="{ 'width': percent }">
      </colgroup>
      <thead>
      <tr>
        <th scope="col" *ngFor="let name of headers">{{name}}</th>
      </tr>
      </thead>
      <tbody>
       <tr *ngFor="let fileRecord of previousFileRecordList"
           [file-record]="fileRecord"
           scope="previous"
           (evtValErrors)="showValidationErrors($event)"
           (evtViewFile)="viewSubmittedFile($event)"></tr>
      </tbody>
    </table>
  </div>
</div>
